import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breakinvestment',
  templateUrl: './breakinvestment.component.html',
  styleUrls: ['./breakinvestment.component.css']
})
export class BreakinvestmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
